import { decode } from "../../config";
import { apiFetch } from "../../utils/api";

const API_BASE_URL = decode(window._env_?.API_BASE_URL);

let allProductsCache = null; // cache to avoid repeated fetching

export const searchAction = (keyword) => async (dispatch) => {
  try {
    if (!allProductsCache) {
      const response = await apiFetch(`${API_BASE_URL}/Product/AllProducts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      allProductsCache = await response.json();
    }
    const filteredData = allProductsCache.filter(
      (dt) =>
        dt.title?.toLowerCase().includes(keyword.toLowerCase()) ||
        dt.description?.toLowerCase().includes(keyword.toLowerCase()) ||
        dt.category.title?.toLowerCase().includes(keyword.toLowerCase())
    );

    dispatch({ type: "SEARCH", payload: filteredData });
  } catch (err) {
    console.error("Error searching products:", err);
  }
};
